// src/components/HelpBar.js
import React from 'react';
import { Link } from 'react-router-dom';
import './HelpBar.css';

export default function HelpBar() {
  return (
    <aside className="help-bar" aria-label="Help and support">
      <div className="help-bar-inner">
        <span className="help-bar-label">Need Help?</span>

        <span className="help-bar-copy">
          Questions about odds, EV, arbitrage, promos, or using BoostYourBets?
        </span>

        <nav className="help-bar-links" aria-label="Support links">
          <a
            className="help-bar-link"
            href="mailto:boostyourbets@gmail.com"
            aria-label="Email us at boostyourbets@gmail.com"
          >
            <span aria-hidden="true">📧</span>
            {/* Desktop: full address; mobile: short label */}
            <span className="help-bar-email-desktop">boostyourbets@gmail.com</span>
          </a>

          <span className="help-bar-sep" aria-hidden="true">|</span>

          <Link
            className="help-bar-link"
            to="/academy"
            aria-label="Watch tutorials in the Academy"
          >
            <span aria-hidden="true">🎓</span>
            {/* Desktop: full label; mobile: short label */}
            <span className="help-bar-academy-desktop">Watch Tutorials in the Academy</span>
            <span className="help-bar-academy-mobile">Academy Tutorials</span>
          </Link>
        </nav>
      </div>
    </aside>
  );
}
